<template>
  <div class="table-row table-row_size-l d-contents text-mm text-primary">
    <div class="cell">
      <span class="file-title text-ellipsis">{{ file.name }}</span>
    </div>
    <div class="cell">
      <span class="text-sm">{{ prettyDates(file.created_at, true) }}</span>
    </div>
    <div class="cell">
      <span>{{ formatBytes(file.size) }}</span>
      <span class="text-sm spacex-4 vertical-centering"> </span>
    </div>
    <div class="cell cell__btn">
      <Spinner v-if="isLoading" size="20" />
      <button v-else type="button" @click.prevent="downloadByLinkHandler(file)">
        <Icon type="download" size="20" />
      </button>
    </div>
  </div>
</template>

<script>
  import { formatBytes } from '@/utils/formatting/format-bytes';
  import prettyDates from '@/utils/formatting/pretty-date';
  import downloadByLink from '@/utils/download-by-link';
  import Spinner from 'vue-simple-spinner';
  import Icon from '@/components/ui/Icon';
  import { mapActions } from 'vuex';

  export default {
    name: 'FilesTableFile',
    components: {
      Spinner,
      Icon,
    },
    props: {
      file: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        isLoading: false,
        error: false,
      };
    },
    methods: {
      ...mapActions('alert', ['showAlert']),
      formatBytes,
      prettyDates,
      downloadByLink,
      async downloadByLinkHandler(file) {
        this.error = false;
        this.isLoading = true;
        try {
          // Функция вернет или ошибку, или ничего в случае успеха
          this.error =
            (await this.downloadByLink({
              link: file.file,
              fileName: file.name,
              withoutAuthorization: true,
            })) || false;
        } catch (e) {
          this.showAlert({
            type: 'error',
            text: this.error,
          });
          console.error(e);
        }
        this.isLoading = false;
      },
    },
  };
</script>
